import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { NewsItem } from "core/http/service/news/resTypes";
import { ReduxStateType } from "redux-store/types";

interface Params {
  from?: string;
  to?: string;
  id?: string;
  limit?: number;
  newsCategoryId?: number;
  offset?: number;
  sort?: string;
  status?: string;
  title?: string;
  displayIndex?: boolean
  indexType?: 'TIN_KHAC' | 'TIN_NOI_BAT'
}

interface InitialState {
  [key: string]: {
    status?: ReduxStateType;
    data?: NewsItem[];
    categoryName?: string;
    controlPage?: { limit: string; offset: string };
  };
}

const initialState: InitialState = {};

const getNewsSlice = createSlice({
  name: "getNews",
  initialState,
  reducers: {
    getNewsStart: (
      state,
      action: PayloadAction<{ type: string; params: Params }>
    ) => {
      const data = state[action.payload.type]?.data ?? []
      state[action.payload.type] = {
        status: ReduxStateType.LOADING,
        data,
        categoryName: state[action.payload.type]?.categoryName ?? '',
      };
    },
    getNewsSuccess: (
      state,
      action: PayloadAction<{
        type: string;
        data: NewsItem[];
        categoryName?: string;
      }>
    ) => {
      state[action.payload.type] = {
        status: ReduxStateType.SUCCESS,
        data: [...state[action.payload.type].data,...action.payload.data],
        categoryName: action.payload.categoryName,
      };

    },
    getNewsFailed: (state, action: PayloadAction<{ type: string }>) => {
      state[action.payload.type] = {
        status: ReduxStateType.ERROR,
        data: [],
      };
    },
    resetNews: (state, action: PayloadAction<{ type: string }>) => {
      state[action.payload.type] = {};
    },
  },
});

export const { getNewsStart, getNewsSuccess, getNewsFailed, resetNews } =
  getNewsSlice.actions;

export default getNewsSlice.reducer;
